import styled from 'styled-components';

import { Autosuggest } from '@dreryk/react-components';

export const StyledPatientField = styled(Autosuggest)`
   width: 392px;
` as typeof Autosuggest;
